import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { nextAsset } from '../../components/nextAsset';

export const BlogCTAContent: React.FC<{ locale: string }> = ({ locale }) => {
  const intl = useIntl();
  const onClick = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    window.onBlogCTAClicked();
  }, []);
  return (
    <div
      className="blog-cta text-white rounded text-center"
      style={{
        backgroundImage: `url("${nextAsset(`logos/quizado-letters-multicolor.svg`)}")`,
        backgroundSize: '200px',
        overflow: 'hidden'
      }}
      role="button"
      onKeyDown={window.onBlogCTAClicked}
      aria-hidden
      onClick={onClick}
    >
      <div
        style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
        className="d-flex flex-column align-items-center justify-content-center w-100 h-100 p-2"
      >
        <div className="mt-2 text-heading text-shadow-primary-opacity" style={{ fontSize: '2rem' }}>
          {intl.formatMessage(
            {
              id: 'web.home.heading.title',
              defaultMessage: 'Wildly fun <b>team building experiences</b>hosted by you'
            },
            {
              b: (children: any) => <div>{children}</div>
            }
          )}
        </div>
        <Button
          color="primary"
          className="text-accent2 text-heading btn-mobile-border mt-2"
          href={`/${locale}/download`}
          onClick={onClick}
        >
          <FormattedMessage id="web.download-now.title" defaultMessage="Check it out for free!" />
        </Button>
      </div>
    </div>
  );
};
